import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AnessaTranslationService } from '../../../helper/translation/anessa-translation.service';
import { ProjectValidation, ValidationSectionName } from '../../../models/data-structures/project-validation';
import { UserpilotReloader } from '../../../helper/userpilot-reloader.component';

@Component({
  selector: 'app-submission-progress-dialog',
  templateUrl: './submission-progress-dialog.component.html',
  styleUrls: [
    './submission-progress-dialog.component.scss',
  ]
})
export class SubmissionProgressDialogComponent extends UserpilotReloader {

  trigger: string;

  showProgress = false;
  validationAccepted = false;

  dataIn: {
    projectValidation: ProjectValidation,
    section: ValidationSectionName,
    onlyShowInvalid: boolean,
    disableConfirmClose: boolean,
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) private projectValidation: ProjectValidation,
    private dialogRef: MatDialogRef<SubmissionProgressDialogComponent>,
    public translationService: AnessaTranslationService,
  ) {
    super();
    if (this.projectValidation) {
      this.dataIn = {
        projectValidation: this.projectValidation,
        section: ValidationSectionName.All,
        onlyShowInvalid: true,
        disableConfirmClose: true,
      };
      this.showProgress = true;
    }
  }

  onSubmitClick() {
    this.dialogRef.close(true);
  }

  onCancelClick() {
    this.dialogRef.close(false);
  }
}
